module.exports = __webpack_public_path__ + "img/43.45c21bc0.jpg";